import { useEffect, useState } from "react";
import type { SjbFeaturedVideo } from "./_props";
import { salonJobResolvedVideoUrl, salonJobResolvedPosterUrl } from "@/lib/_url";
import { fmt } from "@/lib/_format";
import { AutoplayVideo } from "./_video";

export function HeroCarousel({ videos, totalJobs }: { videos: SjbFeaturedVideo[]; totalJobs: number }) {
  const [index, setIndex] = useState(0);
  const list = videos.length > 0 ? videos : [];
  const advance = () => {
    setIndex((i) => (list.length > 0 ? (i + 1) % list.length : 0));
  };

  useEffect(() => {
    if (list.length <= 1) return;
    const t = setInterval(advance, 10000);
    return () => clearInterval(t);
  }, [list.length]);

  if (list.length === 0) {
    return (
      <div className="bg-gradient-to-r from-slate-900 to-slate-700 text-white">
        <div className="max-w-[1800px] mx-auto px-4 py-6 text-center text-sm">動画準備中</div>
      </div>
    );
  }

  const current = list[index];
  return (
    <div className="relative bg-black overflow-hidden">
      <div className="relative w-full max-w-[1800px] mx-auto aspect-[16/9] sm:aspect-[21/9] lg:aspect-[24/9]">
        <AutoplayVideo
          key={current.video_id}
          src={salonJobResolvedVideoUrl(current)}
          poster={salonJobResolvedPosterUrl(current)}
          onEnded={advance}
          className="absolute inset-0 w-full h-full"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-black/10 pointer-events-none" />

        <div className="absolute inset-x-0 bottom-0 p-4 sm:p-6 lg:p-8 text-white">
          <div className="flex items-end justify-between gap-3 flex-wrap">
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2 text-[10px] sm:text-xs font-semibold uppercase tracking-widest text-white/70">
                <span>サロンの空気感まで分かる、新しい求人検索</span>
              </div>
              <h1 className="text-base sm:text-xl lg:text-2xl font-black mt-1 truncate">
                {current.salon_name || "サロン"}
              </h1>
              <div className="text-[11px] sm:text-sm text-white/80 mt-0.5 truncate">
                {current.middle_area && <span className="mr-2">{current.middle_area}</span>}
                {current.title && <span className="opacity-80">/ {current.title}</span>}
              </div>
            </div>
            <div className="text-right">
              <div className="text-[9px] font-semibold uppercase tracking-widest text-white/60">掲載求人</div>
              <div className="text-base sm:text-lg font-bold tabular-nums">
                {fmt(totalJobs)}<span className="text-[10px] ml-0.5 text-white/70">件</span>
              </div>
            </div>
          </div>

          <div className="flex items-center gap-1 mt-3">
            {list.map((v, i) => (
              <button
                key={v.video_id}
                type="button"
                aria-label={`${i + 1}番目の動画`}
                onClick={() => setIndex(i)}
                className={`h-1 rounded-full transition-all ${i === index ? "bg-white w-7" : "bg-white/40 hover:bg-white/70 w-3"}`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
